/** 
 * @Desc: 学习 学习资源列表
 */ 
 <template>
  <draggable
    class="edit-resource-list"
    :class="{
      'drag-ing': dragging,
    }"
    id="editResourceList"
    element="div"
    :list="resourceList"
    :options="{group: 'resource', animation:150, draggable: '.item-wrapper', ghostClass: 'ghostClass', chosenClass: 'chosenClass', dragClass: 'dragClass' }"
    :no-transition-on-drag="true"
    :disabled="true"
    @start.stop="_dragStart"
    @end.stop="_dragEnd"
  >
    <div class="item-wrapper" v-for="(item, index) in resourceList" :key="index">
      <div :class="{
        'item-box': true,
        'no-edit-opreate': !editPower
      }">
        <i
          v-if="false && editPower"
          class="iconfont iconyichu1"
          @click.stop="editPower && $emit('handlerDel', Object.assign(item, {index}))"
        ></i>
        <div class="top-box">
          <div v-if="item.errorType" class="top-box-inner-error">
            <img v-if="item.errorType === 1" src="../../assets/resource-delete.png" alt="">
            <img v-else-if="item.errorType === 2" src="../../assets/resource-error.png" alt="">
          </div>
          <div
            v-else
            :class="{
              'top-box-inner': true,
              'top-box-inner-error': false && item.resourceId && item.shareSourceStatus !== 1,
              'hover-download': showDownload(item)
            }"
            @click.stop="editPower && !showDownload(item) && _previewResource(Object.assign(item, {index})) "
          >
            <CustomeElImage
              v-if="item.id && item.detailSourceType !== 3"
              :src=" item.coverUrl"
              ondragstart="return false;"
              @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
            />
            <CustomeElImage
              v-else-if="item.detailSourceType === 1"
              :src="imgSrc + `/images/${item.preUrl}/${item.resourceId}/${item.coverUrl}`"
              ondragstart="return false;"
              @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
            />
            <CustomeElImage
              v-else-if="item.detailSourceType === 2"
              :src=" item.coverUrl"
              ondragstart="return false;"
              @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
            />
            <template v-else-if="item.detailSourceType === 3">
              <CustomeElImage
                v-if="item.id && item.dataType !== 3"
                :src=" item.coverUrl"
                ondragstart="return false;"
                @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
              />
              <CustomeElImage
                v-else-if="item.dataType !== 3"
                :src=" item.coverUrl"
                ondragstart="return false;"
                @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
              />
              <CustomeElImage
                v-else-if="item.dataType === 3 && item.fileType && (item.fileType === 2 || item.fileType === 3)"
                :src=" item.coverUrl"
                ondragstart="return false;"
                @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
              />
              <CustomeElImage
                v-else-if="item.dataType === 3 && item.type && (item.type === 2 || item.type === 3)"
                :src=" item.coverUrl"
                ondragstart="return false;"
                @click.native.stop="editPower && _previewResource(Object.assign(item, {index})) "
              />
              <!-- 1:音乐文件 2:视频3:图片 0:未知 4:doc 5:ppt 6:pdf 7:xls 8:zip 9:交互课件 10:教案课件 -->
              <div
                v-else
                :class="{
                  'item-image': true,
                  'item-image-other': true,
                  'item-image-1': item.fileType ? item.fileType === 1 : item.type === 1,
                  'item-image-4': item.fileType ? item.fileType === 4 : item.type === 4,
                  'item-image-5': item.fileType ? item.fileType === 5 : item.type === 5,
                  'item-image-6': item.fileType ? item.fileType === 6 : item.type === 6,
                  'item-image-7': item.fileType ? item.fileType === 7 : item.type === 7,
                  'item-image-8': item.fileType ? item.fileType === 8 : item.type === 8,
                  'item-image-9': item.fileType ? item.fileType === 9 : item.type === 9,
                  'item-image-10': item.fileType ? item.fileType === 10 : item.type === 10,
                }"
                @click.stop="editPower && _downloadJudge(Object.assign(item, {index}))"
              >
                <i
                  v-if="item.fileType ? item.fileType === 1 : item.type === 1"
                  class="iconfont iconyinle"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 4 : item.type === 4"
                  class="iconfont iconword"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 5 : item.type === 5"
                  class="iconfont iconPPT"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 6 : item.type === 6"
                  class="iconfont iconPDF"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 7 : item.type === 7"
                  class="iconfont iconexcel"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 8 : item.type === 8"
                  class="iconfont iconzip"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 9 : item.type === 9"
                  class="iconfont iconGSP"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i
                  v-else-if="item.fileType ? item.fileType === 10 : item.type === 10"
                  class="iconfont iconjiaoankejian"
                  :title="editPower ? '下载' : ''"
                ></i>
                <i v-else class="iconfont iconqita"></i>
              </div>
            </template>
            <span class="resource-duration" v-if="item.duration">{{item.duration | tranformTime}}</span>
            <div class="hover-download-bg">
              <i
                class="iconfont iconxiazai"
                title="下载"
                @click.stop="editPower && _downloadJudge(Object.assign(item, {index}))"
              ></i>
            </div>
          </div>
          <span
            v-if="item.detailSourceType <= 2 || (item.detailSourceType === 3 && item.dataType <= 2)"
            class="resource-type"
            :class="'resource-type' + item.type"
          >{{item.type | resourceTypeFilter}}</span>
          <span
            class="abnormal-box"
            v-if="false && item.resourceId && item.shareSourceStatus !== 1"
          >
            <span class="triangle"></span>
            <span class="error cursor" title="资源异常">！</span>
          </span>
        </div>
        <div class="center-box">
          <span class="item-title no-wrap">{{item.resourceTitle}}</span>
          <span class="remark-span no-wrap">备注：{{item.description}}</span>
        </div>
        <div class="bottom-box">
          <i class="iconfont icondaxiao size float-left">{{item.resourceFileSize | fileSize}}</i>
        </div>
        <img
          v-if="editPower && item.isWatched"
          class="resource-complete-img"
          src="../../assets/resource-complete.png"
          alt=""
        >
      </div>
    </div>
    <div
      :disabled="true"
      class="item-wrapper visibility-h"
      v-for="item in addToFlexNum"
      :key="item + 'hidden'"
    >{{item}}</div>
    <!-- 视频预览： mp4 vs4 专题包 播放; PDF预览： 教案 课件 教案课件 习题 交互课件 -->
    <ResourcePreview
      :previewItem="previewItem"
      :resourceList="resourceList"
      :needStatistics="true"
      @handlerResourceClick="_resourceClick"
    />
    <!-- 下载进度的弹窗 -->
    <ResourceDownloadDialog :downloadItem="downloadItem"/>
  </draggable>
</template>
<script>
import Cookies from "js-cookie";
import { originUrl } from "config/constant";
import {
  localStorageUtil,
  debounce,
  getFileSuffix,
  getDownlaodFileName
} from "utils/util";
import draggable from "vuedraggable";
import ResourcePreview from "components/resource-preview";
import ResourceDownloadDialog from "components/resource-download-dialog";
import CustomeElImage from "components/el-image";
export default {
  name: "LearnResource",
  components: {
    draggable,
    ResourcePreview,
    ResourceDownloadDialog,
    CustomeElImage
  },
  props: {
    sort: {
      // 是否可拖拽 默认不可以
      type: Boolean,
      default: false
    },
    resourceList: {
      type: Array
    },
    addToFlexNum: {
      type: Number,
      default: 0
    },
    editPower: {
      type: Boolean,
      default: false
    },
    mediaScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragging: false,
      previewItem: null,
      resourceItem: null,
      downloadItem: null
    };
  },
  computed: {
    imgSrc: function() {
      // 路径
      return originUrl.indexOf("http://localhost:") !== -1
        ? "http://mvr-resource.viewshare.net"
        : originUrl;
    },
    showDownload() {
      // dataType 1:平台资源 2:共享资源 3:我的资源
      // detailSourceType 我的资源的来源： 1:平台资源 2:共享资源 3:原创（自己上传的）
      // type sourceResourceType 1:视频 2:交互课件 3:微课 4:题库子 5:教案 6:课件 7:教案课件
      // fileType 1:音乐文件 2:视频3:图片 0:未知 4:doc 5:ppt 6:pdf 7:xls 8:zip 9:交互课件 10:教案课件
      return item => {
        if (!this.editPower) {
          return false;
        } else if (item.detailSourceType === 3) {
          // 我的资源
          if (item.dataType === 3) {
            // 原创资源
            if (item.fileType === 0 || item.fileType > 3) {
              return true;
            }
          } else {
            // 平台/共享分享
            if (item.sourceResourceType === 2) {
              return true;
            }
          }
        } else if (item.detailSourceType !== 3) {
          // 平台/共享
          if (item.type === 2) {
            return true;
          }
        }
        return false;
      };
    }
  },
  filters: {
    resourceTypeFilter(val) {
      if (val == 1 || val == 21) {
        // 21专题包
        return "微视频";
      } else if (val == 2) {
        return "交互课件";
      } else if (val == 3) {
        return "微课";
      } else if (val == 4) {
        return "习题";
      } else if (val == 5) {
        return "教案";
      } else if (val == 6) {
        return "课件";
      } else if (val == 7) {
        return "教案和课件";
      } else if (val == 10) {
        return "图片";
      } else if (val == 11) {
        return "音频";
      } else {
        return "其他";
      }
    }
  },
  directives: {
    overflowTips1: {
      inserted: function(el) {
        el.onmouseenter = function(e) {
          let $element = $(el);
          let $c = $element
            .clone()
            .css({ display: "inline", width: "auto", visibility: "hidden" })
            .appendTo("body");
          let parent_w = $element.parent().width();
          // console.log('=====',$c.width(), $element.parent()[0].clientWidth, parent_w);
          if ($c.width() > parent_w - 3) {
            $(el).attr({ title: $c.text() });
          } else {
            $(el).attr({ title: "" });
          }
          $c.remove();
        };
      }
    }
  },
  methods: {
    /**
     * 资源拖拽排序--start
     * **/
    _dragStart() {
      this.dragging = true;
    },

    /**
     * 资源拖拽排序--end
     * **/
    _dragEnd() {
      this.dragging = false;
    },
    /**
     * 点击资源
     * **/
    _resourceClick(item) {
      this.$emit("handlerResourceClick", item);
    },

    /**
     * 资源--预览-----------------------------------------preview
     * **/
    _previewResource(item) {
      this.previewItem = Object.assign({}, item);
    },

    /**
     * 资源--下载-----------------------------------------download
     * **/
    _downloadJudge(item) {
      if (
        item.detailSourceType === 3 &&
        item.dataType === 3 &&
        item.fileMime === "mp3"
      ) {
        this._previewResource(item);
        return;
      }
      let obj = this._getDownloadParams(item);
      let _id = obj.documentIds ? obj.documentIds : obj.resourceId;
      if (this.downloadItem) {
        this.downloadItem = null;
        setTimeout(() => {
          this.downloadItem = Object.assign(
            { downloadParams: obj, downloadId: _id },
            item
          );
        }, 50);
      } else {
        this.downloadItem = Object.assign(
          { downloadParams: obj, downloadId: _id },
          item
        );
      }
      this.$emit("handlerResourceClick", item);
    },

    /**
     * 资源--下载--设置发送参数
     * **/
    _getDownloadParams(item) {
      let obj = {
        belongType: item.detailSourceType,
        fileSize: item.resourceFileSize,
        index: item.index,
        isWatched: item.isWatched,
        id: item.id
      };
      if (item.detailSourceType === 1) {
        obj.resourceId = item.resourceId;
        if (item.chapterOneId) {
          obj.chapterOneId = item.chapterOneId;
        }
        if (item.chapterTwoId) {
          obj.chapterTwoId = item.chapterTwoId;
        }
        if (item.chapterThreeId) {
          obj.chapterThreeId = item.chapterThreeId;
        }
      } else if (item.detailSourceType === 2) {
        obj.resourceId = item.customResourceId;
      } else if (item.detailSourceType === 3 && item.documentId) {
        obj.documentIds = item.documentId;
      }
      // type / sourceType : 1:视频 2:交互课件 3:微课 4:题库子 5:教案 6:课件 7:教案课件
      // fileType / subType : 1-Music 2-Video 3-Photo 0-Undefined 4-doc 5-ppt 6-pdf 7-xls 8-zip 9-交互课件 10-教案课件
      let fileName = null;
      if (
        item.detailSourceType <= 2 ||
        (item.detailSourceType === 3 && item.dataType <= 2)
      ) {
        let _itemType = item.subType ? item.subType : item.fileType;
        fileName = getDownlaodFileName(2, item);
        if (item.fileType === 10 || item.fileType === 14 || item.type === 21) {
          // fileType14--我的资源中专题包 type21平台资源中专题包
          fileName = item.resourceTitle + ".zip";
        }
      } else {
        fileName = item.resourceTitle;
      }
      // if(item.fileType === 9 || item.type === 2) {
      //   fileName = item.resourceTitle + '.gsp';
      // }
      obj.fileName = fileName;
      if (obj.resourceId) {
        obj.levelId = item.levelId;
        obj.subjectId = item.subjectId;
        obj.needStatistics = true;
      }
      return obj;
    }
  },
  created() {}
};
</script>
<style lang="less">
.cancel-dowunload-el-dialog {
  .el-dialog__header {
    background: #209f85;
    padding: 10px 30px 10px 24px;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      top: 12px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      text-align: center;
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
.edit-resource-list {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 20px 0 40px;

  .item-wrapper {
    width: 290px;
    height: 270px;
    margin-right: 10px;
    margin-bottom: 20px;

    .item-box {
      width: 100%;
      height: 100%;
      // padding: 12px 14px;
      box-shadow: 0px 4px 12px 0px rgba(0, 56, 56, 0.15);
      border-radius: 5px;
      border: 1px solid #eaeaea;
      // border: 1px solid transparent;
      position: relative;
      .resource-complete-img {
        height: 40px;
        position: absolute;
        bottom: 8px;
        right: 14px;
      }

      &:hover,
      &.item-box-selected {
        &:not(.no-edit-opreate) {
          box-shadow: 0px 0px 10px 0px rgba(147, 147, 147, 0.4);
          border-color: #03b2b2;
        }
        .iconyichu1 {
          display: inline-block;
        }
      }

      .iconyichu1 {
        display: none;
        position: absolute;
        font-size: 20px;
        top: -10px;
        right: -10px;
        color: #f95a5a;
        cursor: pointer;
        background: #fff;
      }

      .top-box {
        width: 100%;
        height: 163px;
        // border-radius: 5px;
        border-bottom: 1px solid #eaeaea;
        position: relative;

        .resource-type {
          position: absolute;
          left: -10px;
          top: 8px;
          z-index: 2;
          border: 2px solid #ffffff;
          border-radius: 4px;
          padding: 4px 6px;
          color: #ffffff;
          font-size: 12px;
          background: linear-gradient(to right, #c0c0c0, #cccc66);

          &.resource-type1,
          &.resource-type21 {
            background: linear-gradient(to right, #ffa322, #ff6337);
          }

          &.resource-type2 {
            background: linear-gradient(to right, #00c6ff, #0072ff);
          }

          &.resource-type3 {
            background: linear-gradient(to right, #75c73b, #55902c);
          }

          &.resource-type4 {
            background: linear-gradient(to right, #667eea, #764ba2);
          }

          &.resource-type5 {
            background: linear-gradient(to right, #ffa0a0, #ff2c00);
          }

          &.resource-type6 {
            background: linear-gradient(to right, #ffb75e, #ed8f03);
          }

          &.resource-type7 {
            background-image: linear-gradient(270deg, #c263d4 0%, #05bdf5 93%);
          }
          // &.resource-type21 {
          //   background: linear-gradient(90deg, #85C2A9 0%, #33BBD3 100%);
          // }
          &.resource-type10 {
            background: linear-gradient(90deg, #4fc6d1 0%, #3c5ebe 100%);
          }

          &.resource-type11 {
            background: linear-gradient(90deg, #e881b7 0%, #a63dac 100%);
          }
        }

        .abnormal-box {
          display: inline-block;
          position: absolute;
          top: 0;
          right: 0;
          width: 28px;
          height: 28px;
          border-top-left-radius: 3px;
          overflow: hidden;
          background: transparent;
          transform: rotate(90deg);

          .triangle {
            display: inline-block;
            position: absolute;
            top: 0;
            right: 0;
            width: 0;
            height: 0;
            border-width: 28px;
            border-style: solid;
            border-color: #f84b62 transparent transparent transparent;
          }

          .error {
            display: inline-block;
            position: absolute;
            top: -1px;
            right: 10px;
            transform: rotate(-90deg);
            color: #fff;
            font-size: 16px;
            font-weight: bold;
          }
        }

        .top-box-inner {
          width: 100%;
          height: 100%;
          text-align: center;
          position: relative;
          border-radius: 4px 4px 0 0;
          overflow: hidden;

          img {
            max-width: 100%;
            height: 100%;
            cursor: pointer;
            transition: all 0.5s;

            &:hover {
              transform: scale(1.1);
            }
          }

          .item-image {
            max-width: 100%;
            height: 100%;
            transition: all 0.5s;

            &:hover {
              transform: scale(1.1);
            }
          }

          div.item-image {
            width: 100%;
            height: 100%;
            position: relative;

            &:hover {
              transform: scale(1);
            }

            .iconfont {
              font-size: 70px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -55%);
              cursor: pointer;
            }

            &.item-image-other {
              background: #e4e2e2;

              .iconfont {
                color: #7c7c7c;
              }
            }

            &.item-image-1 {
              background: #fff5d9;

              .iconfont {
                color: #ffcc33;
              }
            }

            &.item-image-4 {
              background: #e7f4ff;

              .iconfont {
                color: #1296db;
              }
            }

            &.item-image-5 {
              background: #fff2e6;

              .iconfont {
                color: #ff7410;
              }
            }

            &.item-image-6 {
              background: #f7e9e8;

              .iconfont {
                color: #dc2e1b;
              }
            }

            &.item-image-7 {
              background: #d9f7da;

              .iconfont {
                color: #66bb6a;
              }
            }

            &.item-image-8 {
              background: #e4e0f9;

              .iconfont {
                color: #4e3dae;
              }
            }

            &.item-image-9 {
              background: #f7e9e8;

              .iconfont {
                color: #ffc928;
              }
            }

            &.item-image-10 {
              background: #d9f7da;

              .iconfont {
                color: #4c84ff;
              }
            }
          }

          .resource-duration {
            display: inline-block;
            position: absolute;
            bottom: 7px;
            right: 10px;
            color: #fff;
            padding: 4px 6px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 0 4px 0 4px;
            border-radius: 4px;
          }
          .hover-download-bg {
            display: none;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.3);
            // background: rgba(225, 225, 225, 0.4);
            cursor: pointer;
            .iconxiazai {
              font-size: 34px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              color: #03b2b2;
              // color: #fff;
            }
          }
          &.hover-download:hover {
            .hover-download-bg {
              display: inline-block;
            }
          }
        }

        .top-box-inner-error {
          width: 100%;
          height: 100%;
          background: #f0f0f0;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) !important;

            &:hover {
              transform: translate(-50%, -50%) scale(1) !important;
            }
          }
        }
      }

      .center-box {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
        padding: 0 16px;

        .item-title {
          display: inline-block;
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          font-weight: bold;
          color: #5d5d5d;
          text-align: left;
        }
        .remark-span {
          display: inline-block;
          width: 100%;
          color: #9a9a9a;
        }

        .size {
          color: #7c7c7c;
          font-size: 14px;
        }
      }

      .bottom-box {
        padding: 0 16px;
        .resource-description {
          display: inline-block;
          width: 100%;
          color: #666666;
          height: 40px;
          line-height: 20px;
        }
        .icondaxiao {
          font-size: 14px;
          color: #a5a5a5;
          &:before {
            padding-right: 4px;
          }
        }

        .iconxiazai {
          color: #67bf9d;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .no-edit-opreate {
      cursor: default !important;

      &:hover,
      &.item-box-selected {
        &:not(.no-edit-opreate) {
          border-color: transparent;
        }
      }

      .top-box {
        img {
          cursor: default !important;
          transform: scale(1) !important;
        }

        div.item-image {
          .iconfont {
            cursor: default !important;
          }
        }
      }
    }
  }

  &.drag-ing {
    .item-wrapper {
      .item-box:hover {
        border-color: transparent;

        .iconyichu1 {
          display: none;
        }
      }
    }
  }

  .ghostClass {
    .item-box {
      .iconyichu1 {
        display: none;
      }
    }
  }

  .chosenClass {
    .item-box {
      border-color: #66bb6a !important;
      box-shadow: 0px 10px 20px 4px rgba(110, 110, 110, 0.23);

      .iconyichu1 {
        // display: none !important;
      }
    }
  }

  .dragClass {
    .item-box {
      border-color: #66bb6a;
    }
  }
}
</style>